<template>
	<div>
		<div class="actDiv">
			<a-button size="small"  icon="plus" @click="showAddWindow">新增权限</a-button>
		</div>
		<a-table  size="small" :columns="columns" :data-source="list" bordered :loading="loading"  rowKey="pid" :pagination="false"  :scroll="{y:600}">
			<span slot="checkSystemRole"  slot-scope="text, record">
				{{record.SystemRole == 1?'是':'否'}}
			</span>
			<span slot="theAction" slot-scope="text, record">
			      <a-button size="small" type="link" @click="viewContent(record)">查看</a-button>
				  <a-button size="small" type="link" @click="editContent(record)">修改</a-button>
			</span>
		</a-table>
		<a-drawer :title="theTitle" :visible="showFlag"  width="600" @close="onClose" :destroyOnClose='true' :maskClosable="false">
			<ShowAuthorityList :theObj = "theObj" :editFlag="editFlag" @onClose="onClose" @refreshList="queryDataList" />
		</a-drawer>
	</div>
</template>

<script>
	const columns = [
		{
			title: '权限',
			dataIndex: 'RoleName',
			className:'v-cell',
			align:'center',
		},
		{
			title: '系统权限',
			dataIndex: 'SystemRole',
			scopedSlots:{customRender:'checkSystemRole'},
			className:'v-cell',
			align:'center',
		},
		{
			title:'备注',
			dataIndex:'Remark',
			className:'v-cell',
			align:'center',
		},
		{
		    title: '操作',
		    key: 'pid',
		    scopedSlots: { customRender: 'theAction' },
			className:'v-cell',
			align:'center',
			width:130,
		  },
	];
	import ShowAuthorityList from '../components/ShowAuthorityList.vue'
	export default{
		components:{
			ShowAuthorityList,
		},
		data(){
			return{
				loading:true,
				list:[],
				showFlag:false,
				columns,
				theObj:{},
				theTitle:'',
				editFlag:false,
			}
		},
		methods:{
			queryDataList:function(){
				let url = this.Api.getLastUrl(this.Api.ROLE_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			viewContent:function(item){
				this.theTitle = '查看详情';
				this.showFlag = true;
				this.editFlag = false;
				this.theObj = this.Config.deepClone(item);
			},
			editContent:function(item){
				this.theTitle = '修改权限';
				//得先展示出来
				this.showFlag = true;
				this.editFlag = true;
				this.theObj = this.Config.deepClone(item);
			},
			onClose:function(){
				this.showFlag = false;
			},
			showAddWindow:function(){
				this.theTitle = '新增权限';
				this.showFlag = true;
				this.theObj = {RoleName:'',Remark:'',PID:0};
			}
		},
		created() {
			this.queryDataList();
		}
	}
</script>

<style>
</style>
